module.exports = __webpack_public_path__ + "img/export-nothing.d987f41e.png";